import React from 'react';
import useStyles from 'apps/Pdf/components/common/styles/H1';

interface Props {
  children: React.ReactNode;
  className?: string;
  numbered?: boolean;
}

const H1 = (props: Props) => {
  const classes = useStyles();
  const { children, className, numbered } = props;

  return (
    <h1
      className={`${classes.root} bgrDark${numbered ? ' numbered' : ''}${
        className ? ' ' + className : ''
      }`}
    >
      {children}
    </h1>
  );
};

export default H1;
